import { t } from "@/i18n-js/instance";
import { usePlansModal } from "@/react/components/shared/PlansModal";
import { useTrialBanner } from "./useTrialBanner";

export const PlansModalButton = () => {
  const plansModal = usePlansModal();
  const { trialDaysRemainingInWords, trialEndDateFormatted } = useTrialBanner();

  return (
    <div>
      {t("trial_banner.trial_ends_in", {
        trialDaysRemainingInWords,
        trialEndDateFormatted,
      })}
      <button
        type="button"
        className="hover:!text-badge text-badge ml-1 cursor-pointer underline"
        onClick={() => {
          void plansModal.show();
        }}
      >
        {t("trial_banner.upgrade_plan")}
      </button>{" "}
      {t("trial_banner.before_trial_expires")}
    </div>
  );
};
